import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {AngularFireModule} from 'angularfire2';
import {AngularFireDatabaseModule} from 'angularfire2/database';
import {AngularFireAuthModule} from 'angularfire2/auth';
import {ListChatComponent} from './container/list-chat/list-chat.component';
import {ConversationChatComponent} from './container/conversation-chat/conversation-chat.component';
import {ChatComponent} from './container/chat/chat.component';
import {ChatRoutingModule} from './chat-routing.module';
import {ChatService} from 'src/app/business/chat/service/chat.service';
import {AuthService} from 'src/app/business/chat/service/auth.service';
import {environment} from 'src/environments/environment';
import {NzUploadModule} from 'ng-zorro-antd/upload';
import {SharedModule} from '../../shared';
import {NzButtonModule} from 'ng-zorro-antd/button';
import {NzRadioModule} from 'ng-zorro-antd/radio';
import {NzTableModule} from 'ng-zorro-antd/table';
import {NgxPaginationModule} from 'ngx-pagination';
import {AngularFirestore} from 'angularfire2/firestore';
import {NgZorroAntdModule, vi_VN, NZ_I18N, en_US} from 'ng-zorro-antd';
import {NzIconModule} from 'ng-zorro-antd/icon';
import { ListChatConversationComponent } from './container/list-chat-conversation/list-chat-conversation.component';
import { MomentPipe } from './moment.pipe';

import { ListUnreadConversationComponent } from './container/list-unread-conversation/list-unread-conversation.component';

// import {ModalModule} from 'ngx-bootstrap';




@NgModule({
  declarations: [
    ListChatComponent,
    ConversationChatComponent,
    ChatComponent,
    ListChatConversationComponent,
    MomentPipe,

    ListUnreadConversationComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    ChatRoutingModule,
    NzUploadModule,
    SharedModule,
    NzButtonModule,
    NzRadioModule,
    NzTableModule,
    NgxPaginationModule,
    NgZorroAntdModule,
    NzIconModule,
    // ModalModule.forRoot(),
    // TimeagoModule.forChild({
    //   intl: {provide: TimeagoIntl, useClass: MyIntl},
    //   formatter: {provide: TimeagoFormatter, useClass: TimeagoCustomFormatter}
    // }),
  ],
  providers: [ChatService, AuthService, AngularFirestore]
})
export class ChatModule {
}
